<template>
  <BaseCell :align="align">
    <span v-if="!risk">-</span>
    <span v-else class="risk-chip">
      <div :style="bulletStyle" class="risk-chip__bullet" />
      {{ risk.formatted }}
    </span>
  </BaseCell>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { BaseCell } from '@warrenbrasil/nebraska-web';

interface Props {
  risk: { formatted: string; color: string } | null;
  align?: string;
}
const { risk } = withDefaults(defineProps<Props>(), {
  risk: null,
  align: 'right'
});

const bulletStyle = computed(() => {
  return { backgroundColor: risk?.color };
});
</script>

<style lang="less" scoped>
.risk-chip {
  .text-p-6();
  background-color: @background-tertiary;
  padding: @size-spacing-x150 @size-spacing-x300;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: @size-radius-x100;

  &__bullet {
    min-width: 6px;
    min-height: 6px;
    border-radius: @size-radius-x200;
    display: inline-block;
    margin-right: calc(@size-spacing-x150 + @size-spacing-x75);
  }
}
</style>
